import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorResponse } from '@app/models/note.model';

const messages = [
  { status: 404, text: 'ページが見つかりません' },
  { status: 403, text: '権限がありません' },
  { status: 409, text: 'データが競合しているためリクエストを完了できません' },
];

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  constructor() {}

  getHttpErrorMessage(error: HttpErrorResponse) {
    let errorMessage = error.error?.error?.message || error.error;
    if (errorMessage) return errorMessage;

    const message = messages.find((item) => item.status === error.status);
    return message?.text ?? 'サービスが利用できません';
  }

  getErrorMessage(error: ErrorResponse) {
    const errorMessage = error.message;
    if (errorMessage) return errorMessage;

    const message = messages.find((item) => item.status === error.code);
    return message?.text ?? 'サービスが利用できません';
  }
}
